import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'frontline-docoment-return-confirm-dialog',
  templateUrl: './frontline-docoment-return-confirm-dialog.component.html',
  styleUrls: ['./frontline-docoment-return-confirm-dialog.component.scss']
})
export class FrontlineDocomentReturnConfirmDialogComponent implements OnInit {
  @Input() title: string = '';
  @Input() isVisible: boolean = false;
  @Input() showInput: boolean = false;
  @Input() showRadio: boolean = false;
  @Output() onConfirm = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      reason: [''],
      decision: ['accept']
    });
  }

  ngOnInit() {
    this.resetForm();

    this.form.get('decision')?.valueChanges.subscribe(value => {
      const reasonControl = this.form.get('reason');
      if (value === 'reject') {
        reasonControl?.setValidators([Validators.required]);
        this.showInput = true;
      } else {
        reasonControl?.clearValidators();
        this.showInput = false;
      }
      reasonControl?.updateValueAndValidity();
    });
  }

  confirm() {
    console.log('Confirm button clicked:', this.form.value);
    
    // 特殊情況：當拒絕時，確保有理由
    if (this.showRadio && this.form.get('decision')?.value === 'reject') {
      const reasonValue = this.form.get('reason')?.value;
      if (!reasonValue || reasonValue.trim() === '') {
        console.error('拒絕時必須提供理由');
        return;
      }
    }
    
    // 特殊情況：當顯示輸入框時，確保有輸入內容
    if (this.showInput) {
      const reasonValue = this.form.get('reason')?.value;
      if (!reasonValue || reasonValue.trim() === '') {
        console.error('必須提供原因');
        return;
      }
    }
    
    // 驗證通過，發出確認事件
    if (this.form.valid) {
      console.log('Confirm button clicked(valid):', this.form.value);
      this.onConfirm.emit(this.form.value);
      this.resetForm();
      this.isVisible = false;
    }
  }
  
  updateDialogContent(title: string, showInput?: boolean, showRadio?: boolean) {
    this.title = title;
    if (showInput){this.showInput = showInput;}
    if (showRadio){this.showRadio = showRadio;}
    this.resetForm();
  }

  cancel() {
    this.onCancel.emit();
    this.resetForm();
    this.isVisible = false;
  }

  resetForm() {
    this.form.reset({
      reason: '',
      decision: 'accept'
    });
  }
}